import { styled, Stack, Button } from '@mui/material';

export const StyledCardContainer = styled(Stack)(({ theme }) => ({
  padding: 16,
  borderRadius: 10,
  gap: 10,
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 3px 24px 0px rgba(0,0,0,0.10)',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StyledEditCardContainer = styled(Stack)(({ theme }) => ({
  padding: 16,
  borderRadius: 10,
  gap: 10,
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 3px 24px 0px rgba(0,0,0,0.10)',
}));

export const CardContainerIcon = styled(Stack)(({ theme }) => ({
  color: theme.palette.red300.main,
  borderRadius: 4,
  alignItems: 'center',
  padding: '6px 7px',
  backgroundColor: theme.palette.red300.main + '10',
}));

export const ImageContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: 250,
  color: theme.palette.gray300.main,
  backgroundColor: theme.palette.gray100.main,
  borderRadius: 10,
}));

export const DeleteButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: 13,
  borderRadius: 8,
  backgroundColor: theme.palette.white.main,
  border: `1px solid ${theme.palette.red.main}`,
  color: theme.palette.red.main,
  '&:hover': {
    backgroundColor: theme.palette.white.main,
  },
  '&.Mui-disabled': {
    border: `1px solid ${theme.palette.gray500.main}`,
    color: theme.palette.gray300.main,
    backgroundColor: theme.palette.gray200.main,
  },
}));
